
import React from 'react';
import { Collapsible, CollapsibleTrigger, CollapsibleContent } from '@/components/ui/collapsible';
import { Button } from '@/components/ui/button';
import { ChevronDown, ChevronUp } from 'lucide-react';
import type { DebugInfo } from '../types/debugTypes';

interface SuccessDisplayProps {
  debugInfo: DebugInfo;
  showDebugInfo: boolean;
  setShowDebugInfo: (show: boolean) => void;
}

export function SuccessDisplay({
  debugInfo,
  showDebugInfo,
  setShowDebugInfo
}: SuccessDisplayProps) {
  return (
    <div className="w-full mt-4">
      <Collapsible 
        open={showDebugInfo} 
        onOpenChange={setShowDebugInfo}
        className="w-full border border-green-200 rounded-md"
      >
        <div className="bg-green-50 p-4 rounded-t-md flex items-center justify-between">
          <span className="font-medium text-green-800">Enrichment Initiated</span>
          <CollapsibleTrigger asChild>
            <Button variant="ghost" size="sm">
              {showDebugInfo ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
              {showDebugInfo ? 'Hide' : 'Show'} Details
            </Button>
          </CollapsibleTrigger>
        </div>
        
        <CollapsibleContent className="p-4 bg-white border-t border-green-100">
          <h4 className="font-medium mb-2">Response Data</h4>
          <pre className="bg-gray-50 p-3 rounded text-sm overflow-auto max-h-96">
            {JSON.stringify(debugInfo, null, 2)}
          </pre>
        </CollapsibleContent>
      </Collapsible>
    </div>
  );
}
